document.addEventListener('alpine:init', () => {
  Alpine.data('readmore', () => ({
    lines: 6,
    fullHeight: 0,
    collapsedHeight: 0,
    expandable: false,
    measureCollapsedHeight() {
      const source = this.$refs.text;
      const clone = source.cloneNode(true);

      clone.style.position = 'absolute';
      clone.style.visibility = 'hidden';
      clone.style.pointerEvents = 'none';
      clone.style.zIndex = '-1';
      clone.style.left = '0';
      clone.style.top = '0';
      clone.style.width = source.offsetWidth + 'px';
      clone.style.maxHeight = 'none';
      clone.style.overflow = 'visible';
      clone.style.transition = 'none';
      clone.style.display = '-webkit-box';
      clone.style.webkitBoxOrient = 'vertical';
      clone.style.webkitLineClamp = String(this.lines);

      source.parentNode.appendChild(clone);
      const height = clone.offsetHeight;
      clone.remove();

      return height;
    },
    initHeights() {
      this.$nextTick(() => {
        this.fullHeight = this.$refs.text.scrollHeight;
        this.collapsedHeight = this.measureCollapsedHeight();
        this.expandable = this.fullHeight > this.collapsedHeight + 1;

        if (!this.expandable) {
          this.collapsedHeight = this.fullHeight;
        }
      });
    }
  }))
})
